export default "__VITE_ASSET__C$t0wpA5__"